import React, { createContext, useContext, useState } from 'react';

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const [disapprovedCount, setDisapprovedCount] = useState(0);

  const updateDisapprovedCount = (count) => {
    setDisapprovedCount(count);
  };

  return (
    <NotificationContext.Provider value={{ disapprovedCount, updateDisapprovedCount }}>
      {children}
    </NotificationContext.Provider>
  );
};
